import classes from "./SuccessMsg.module.css";

export function SuccessMsg({ msg }) {
  return (
    <div className={classes.container}>
      <h4>{msg}</h4>
    </div>
  );
}
